/* eslint-disable no-unused-vars */
import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import IntlMessages from '@crema/utility/IntlMessages';
import {BiUser} from 'react-icons/bi';
import {AiOutlineLock} from 'react-icons/ai';
import {IoMdInformationCircleOutline} from 'react-icons/io';
import {MdOutlineRecommend} from 'react-icons/md';
import {IoShareSocialOutline} from 'react-icons/io5';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AccountTabsWrapper from './AccountTabsWrapper';
import PersonalInfo from './PersonalInfo';
import ChangePassword from './ChangePassword';
import ReferralEmail from './ReferralEmail';
import Information from './Information';
import BillingInformation from './BillingInformation';
import Social from './Social';
import Notification from './Notification';
import accountData from '@crema/services/db/account';
import AppAnimate from '@crema/core/AppAnimate';
import {Fonts} from 'shared/constants/AppEnums';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const tabs = [
  {id: 1, icon: <BiUser />, name: <IntlMessages id='common.personalInfo' />},
  {
    id: 2,
    icon: <IoMdInformationCircleOutline />,
    name: <IntlMessages id='common.billingInformation' />,
  },
  {
    id: 3,
    icon: <AiOutlineLock />,
    name: <IntlMessages id='common.changePassword' />,
  },
  {
    id: 4,
    icon: <MdOutlineRecommend />,
    name: <IntlMessages id='common.referral' />,
  },

  // {
  //   id: 4,
  //   icon: <IoMdInformationCircleOutline />,
  //   name: <IntlMessages id='common.billingInformation' />,
  // },
  // {
  //   id: 5,
  //   icon: <NotificationsNoneIcon />,
  //   name: <IntlMessages id='healthCare.notification' />,
  // },
];

const Account = () => {
  const [value, setValue] = React.useState(0);

  const onTabsChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box
        component='h2'
        variant='h2'
        sx={{
          fontSize: 16,
          color: 'text.primary',
          fontWeight: Fonts.SEMI_BOLD,
          mb: {
            xs: 2,
            lg: 4,
          },
        }}
      >
        My Account
      </Box>
      <AppAnimate animation='transition.slideUpIn' delay={200}>
        <AccountTabsWrapper>
          <Tabs
            className='account-tabs'
            value={value}
            onChange={onTabsChange}
            aria-label='basic tabs example'
            orientation='vertical'
          >
            {tabs.map((tab, index) => (
              <Tab
                className='account-tab'
                label={tab.name}
                icon={tab.icon}
                key={index}
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
          <Box className='account-tabs-content'>
            {value === 0 && <PersonalInfo />}
            {value === 1 && <BillingInformation />}
            {value === 2 && <ChangePassword />}
            {value === 3 && <ReferralEmail />}
            {/* {value === 3 && <Social social={accountData.member} />} */}
            {/* {value === 4 && <Notification />} */}
          </Box>
        </AccountTabsWrapper>
      </AppAnimate>
    </>
  );
};

export default Account;
